module.exports = __webpack_public_path__ + "img/nav-design-fullsize@2x.6ab104e.webp";